module.exports = __webpack_public_path__ + "img/FactsLogoBg.11aa4eb9.png";